import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
export var PrehydrationClickTrackingWrapper = function(param) {
    var name = param.name, isRsc = param.isRsc, location = param.location, className = param.className, children = param.children;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                "data-prehydration-on-click": 'trackEvent && trackEvent("retailers-prehydration_click-click", [\n          "'.concat(name, '",\n          ').concat(isRsc ? '"true"' : '"false"', ',\n          "').concat(location, '"\n        ])'),
                onClick: function() {},
                className: className,
                children: children
            }),
            /*#__PURE__*/ _jsx("script", {
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: getClickTrackingScript()
                }
            })
        ]
    });
};
/**
 * This is run in server-rendered contexts.
 * This script is used to convert data-prehydration-on-click attributes to onclick attributes
 * which will be fired even when no JS is enabled. This is to track clicks before hydration.
 */ var getClickTrackingScript = function() {
    return "\n  document.querySelectorAll('[data-prehydration-on-click]').forEach(el => {\n    const dataOnClick = el.getAttribute('data-prehydration-on-click');\n    el.setAttribute('onclick', dataOnClick);\n  });\n";
};
